<script lang="ts" setup>
	const { passwordValidationDemands } = defineProps<{
		passwordValidationDemands: { label: string; passed: boolean }[]
	}>()
</script>
<template>
	<div>
		<div class="mx-auto my-8 flex max-w-[450px] flex-wrap items-center gap-3 sm:my-12 sm:justify-center">
			<div v-for="(item, index) in passwordValidationDemands" :key="index" class="flex items-center gap-2">
				<lazy-tools-icon
					icon="curve-check-2"
					dir="fill"
					:path-class="item.passed ? 'fill-success-500' : 'fill-gray-400'"
				/>
				<span :class="[item.passed ? 'text-success-500' : 'text-gray-400']">
					{{ item.label }}
				</span>
			</div>
		</div>
	</div>
</template>
